<template>
    <div>
        <Modal v-model="preViewModal.show"
            :width="1000"
            title="预览发票">
            <div style="color:rgb(241, 115, 72);font-size:14px;">
                <div style="display:flex;justify-content:space-between;align-items: center;">
                    <div style="width:330px;"></div>
                    <div style="font-size:24px;width:330px;text-align:center;">{{isDigital ? '（电子发票）' : ''}}增值税虚拟发票</div>
                    <div style="width:330px;text-align:right;">
                        <span>开票日期:</span>
                        <span style="color:black;margin-left:4px;">{{getCurrentDate()}}</span>
                    </div>
                </div>
                <div v-if="isDigital" style="border-top: 0.5px solid; border-left: 0.5px solid;border-color:black;margin-top:10px;">
                    <div style="display:flex;align-items: center;">
                        <div class="vertical-text invoiceBorder"
                            style="width:30px;height:90px;">购买方信息</div>
                        <div class="invoiceBorder"
                            style=" width:470px;height:90px;display: flex;justify-content: center;flex-direction: column;padding-left:4px;">
                            <div>
                                <span>名&emsp;&emsp;&emsp;&emsp;称:</span><span style="color:black;margin-left:4px;">{{preViewModal.invoiceModel.invoiceBuyerName}}</span>
                            </div>
                            <div>
                                <span>纳税人识别号:</span><span style="color:black;margin-left:4px;">{{preViewModal.invoiceModel.invoiceBuyerTaxNum}}</span>
                            </div>
                        </div>
                        <div class="vertical-text invoiceBorder"
                            style="width:30px;height:90px;">销售方信息</div>
                        <div class="invoiceBorder"
                            style=" width:470px;height:90px;display: flex;justify-content: center;flex-direction: column;padding-left:4px;">
                            <div>
                                <span>名&emsp;&emsp;&emsp;&emsp;称:</span><span style="color:black;margin-left:4px;">广州缤纷园艺有限公司</span>
                            </div>
                            <div>
                                <span>纳税人识别号:</span><span style="color:black;margin-left:4px;">{{preViewModal.salerTaxNum}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else style="border-top: 0.5px solid; border-left: 0.5px solid;border-color:black;margin-top:10px;">
                    <div style="display:flex;align-items: center;">
                        <div class="vertical-text invoiceBorder"
                            style="width:30px;height:90px;">购买方</div>
                        <div class="invoiceBorder"
                            style=" width:470px;height:90px;display: flex;justify-content: center;flex-direction: column;padding-left:4px;">
                            <div>
                                <span>名&emsp;&emsp;&emsp;&emsp;称:</span><span style="color:black;margin-left:4px;">{{preViewModal.invoiceModel.invoiceBuyerName}}</span>
                            </div>
                            <div>
                                <span>纳税人识别号:</span><span style="color:black;margin-left:4px;">{{preViewModal.invoiceModel.invoiceBuyerTaxNum}}</span>
                            </div>
                            <div>
                                <span>地址&emsp;、电话:</span><span style="color:black;margin-left:4px;">{{preViewModal.invoiceModel.invoiceBuyerAddress}} {{preViewModal.invoiceModel.invoiceBuyerTel}}</span>
                            </div>
                            <div>
                                <span>开户行及账号:</span><span style="color:black;margin-left:4px;">{{preViewModal.invoiceModel.invoiceBuyerBank}} {{preViewModal.invoiceModel.invoiceBuyerAccount}} </span>
                            </div>
                        </div>
                        <div class="vertical-text invoiceBorder"
                            style="width:30px;height:90px;">密码区</div>
                        <div class="invoiceBorder"
                            style=" width:470px;height:90px;"></div>
                    </div>
                </div>
                <div style="display:flex;line-height:2;border-left:0.5px solid;border-color:black;">
                    <div class="invoiceBorder"
                        style="width:300px;height:30px;text-align:center;">项目名称</div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;">规格型号</div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;">单位</div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;">数量</div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;">单价</div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;">金额</div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;">税率</div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;">税额</div>
                </div>
                <div v-for="item in preViewModal.productList"
                    style="display:flex;line-height:2;border-left:0.5px solid;border-color:black;color:black;">
                    <div class="invoiceBorder"
                        style="width:300px;height:30px;text-align:center;">{{item.productName}}</div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;">{{item.productSpec}}</div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;">{{item.unit}}</div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;">{{item.quantity}}</div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;">{{numberToFixed(item.price,4)}}</div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;">{{numberToFixed(item.value,4)}}</div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;">{{item.taxRate * 100}}%</div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;">{{numberToFixed(item.taxValue,4)}}</div>
                </div>
                <div style="display:flex;line-height:2;border-left:0.5px solid;border-color:black;color:black;">
                    <div class="invoiceBorder"
                        style="width:300px;height:30px;text-align:center;color:rgb(241, 115, 72);">合计</div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;"></div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;"></div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;"></div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;"></div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;">{{numberToFixed(preViewModal.totalValue,4)}}</div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;"></div>
                    <div class="invoiceBorder"
                        style="width:100px;height:30px;text-align:center;">{{numberToFixed(preViewModal.totalTax,4)}}</div>
                </div>
                <div style="display:flex;line-height:2;border-left:0.5px solid;border-color:black;color:black;">
                    <div class="invoiceBorder"
                        style="width:300px;height:30px;text-align:center;color:rgb(241, 115, 72);">价税合计(大写)</div>
                    <div class="invoiceBorder"
                        style="width:700px;height:30px;text-align:center;display:flex;justify-content:space-between;padding:0 30px;">
                        <span>{{smalltoBIG(preViewModal.invoiceModel.invoiceValue)}}</span>
                        <div>
                            <span style="color:rgb(241, 115, 72);">（小写）</span>
                            <span>￥{{numberToFixed(preViewModal.invoiceModel.invoiceValue,2)}}</span>
                        </div>
                    </div>
                </div>

                <div v-if="isDigital" style=" border-left: 0.5px solid;border-color:black;">
                    <div style="display:flex;align-items: center;">
                        <div class="vertical-text invoiceBorder"
                            style="width:30px;height:90px;">备注</div>
                        <div class="invoiceBorder"
                            style=" width:950px;height:90px;"></div>
                    </div>
                </div>
                <div v-else style=" border-left: 0.5px solid;border-color:black;">
                    <div style="display:flex;align-items: center;">
                        <div class="vertical-text invoiceBorder"
                            style="width:30px;height:90px;">销售方</div>
                        <div class="invoiceBorder"
                            style=" width:470px;height:90px;display: flex;justify-content: center;flex-direction: column;padding-left:4px;">
                            <div>
                                <span>名&emsp;&emsp;&emsp;&emsp;称:</span><span style="color:black;margin-left:4px;">广州缤纷园艺有限公司</span>
                            </div>
                            <div>
                                <span>纳税人识别号:</span><span style="color:black;margin-left:4px;">{{preViewModal.salerTaxNum}}</span>
                            </div>
                            <div>
                                <span>地址&emsp;、电话:</span><span style="color:black;margin-left:4px;">{{preViewModal.salerAddress}}</span>
                            </div>
                            <div>
                                <span>开户行及账号:</span><span style="color:black;margin-left:4px;">{{preViewModal.bankInfo}} </span>
                            </div>
                        </div>
                        <div class="vertical-text invoiceBorder"
                            style="width:30px;height:90px;">备注</div>
                        <div class="invoiceBorder"
                            style=" width:470px;height:90px;"></div>
                    </div>
                </div>

                <div v-if="isDigital" style="display: flex;justify-content:space-between;margin-top:4px;">
                    <div style="width:250px;"><span>开票人:</span><span style="color:black;margin-left:4px;">{{preViewModal.clerk}}</span></div>
                </div>
                <div v-else style="display: flex;justify-content:space-between;margin-top:4px;">
                    <div style="width:250px;"><span>收款人:</span><span style="color:black;margin-left:4px;">{{preViewModal.payee}}</span></div>
                    <div style="width:250px;"><span>复核:</span><span style="color:black;margin-left:4px;">{{preViewModal.checker}}</span></div>
                    <div style="width:250px;"><span>开票人:</span><span style="color:black;margin-left:4px;">{{preViewModal.clerk}}</span></div>
                    <div style="width:250px;"><span>销售方:</span><span>（章）</span></div>
                </div>
            </div>

            <div slot="footer">
                <Button :loading="preViewModal.loading"
                    type="primary"
                    @click="onConfirmApplyInvoice()">提交开票</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import api from '@/api/api';
import { formatDateTimeString, numberToFixed } from "@/libs/utils";
export default {
    name: "InvoicePreviewModal",
    mounted() {
    },
    data() {
        return {
            preViewModal: {
                show: false,
                loading: false,
                invoiceModel: {},
                productList: [],
                clerk: '',
                payee: '',
                checker: '',
                salerTaxNum: '',
                salerTel: '',
                bankInfo: '',
                salerAddress: ''
            }
        };
    },
    computed: {
        isDigital() {
            return this.preViewModal.invoiceModel.invoiceLine1.indexOf('数电') >= 0;
        }
    },
    methods: {
        numberToFixed,
        showModal(data) {
            Object.assign(this.preViewModal, data);

            this.preViewModal.totalValue = 0;
            this.preViewModal.totalTax = 0;
            this.preViewModal.productList.forEach(e => {
                this.preViewModal.totalValue += e.value;
                this.preViewModal.totalTax += e.taxValue;
            });

            this.preViewModal.show = true;
            console.log(this.preViewModal);
        },
        onConfirmApplyInvoice() {
            this.preViewModal.loading = true;
            api.webSubmitInvoice({ InvoiceUuid: this.preViewModal.invoiceModel.invoiceUuid }).then(res => {
                this.preViewModal.loading = false;
                if (res.code === 0) {
                    this.$bvModal.msgBoxOk("提交成功", {
                        title: '提示',
                        buttonSize: 'sm'
                    });
                    this.preViewModal.show = false;
                    this.$parent.refreshInvoice();
                }
            });
        },
        smalltoBIG(n) {
            let fraction = ['角', '分'];
            let digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
            let unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']];
            let head = n < 0 ? '欠' : '';
            n = Math.abs(n);

            let s = '';

            for (let i = 0; i < fraction.length; i++) {
                s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
            }
            s = s || '整';
            n = Math.floor(n);

            for (let i = 0; i < unit[0].length && n > 0; i++) {
                let p = '';
                for (let j = 0; j < unit[1].length && n > 0; j++) {
                    p = digit[n % 10] + unit[1][j] + p;
                    n = Math.floor(n / 10);
                }
                s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
            }
            return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');
        },
        getCurrentDate() {
            let now = new Date();
            let year = now.getFullYear(); //得到年份
            let month = now.getMonth();//得到月份
            let date = now.getDate();//得到日期
            month = month + 1;
            if (month < 10) month = "0" + month;
            if (date < 10) date = "0" + date;
            let time = "";
            time = year + "年" + month + "月" + date + "日";
            return time;
        }

    }

};
</script>

<style>
.vertical-text {
    -webkit-writing-mode: vertical-rl;
    writing-mode: vertical-rl;
    text-align: center;
    line-height: 2;
}
.invoiceBorder {
    border-right: 0.5px solid;
    border-bottom: 0.5px solid;
    border-color: black;
}
</style>





// WEBPACK FOOTER //
// src/view/member/invoice-preview.vue